import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_tasksService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], top?: number, minCreationDate?: string, minId?: number }): 
  Promise<{ result: { Id?: number, Amount?: number, BillingCodeId?: number, BillingContractLineId?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, BillingRecord?: { ApplicableMinimumCharge?: number, ApplicableRate?: number, InvoiceLineId?: number }, Shipment?: { LookupCode?: string }, BillingContractLine?: { BillingAggregationStrategyId?: number, LineNumber?: number, BillingAggregationStrategy?: { Name?: string } }, Warehouse?: { Name?: string }, Project?: { LookupCode?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_tasks/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], top?: number, minCreationDate?: string, minId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Amount?: number, BillingCodeId?: number, BillingContractLineId?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, BillingRecord?: { ApplicableMinimumCharge?: number, ApplicableRate?: number, InvoiceLineId?: number }, Shipment?: { LookupCode?: string }, BillingContractLine?: { BillingAggregationStrategyId?: number, LineNumber?: number, BillingAggregationStrategy?: { Name?: string } }, Warehouse?: { Name?: string }, Project?: { LookupCode?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_tasks/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], top?: number, minCreationDate?: string, minId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Amount?: number, BillingCodeId?: number, BillingContractLineId?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, BillingRecord?: { ApplicableMinimumCharge?: number, ApplicableRate?: number, InvoiceLineId?: number }, Shipment?: { LookupCode?: string }, BillingContractLine?: { BillingAggregationStrategyId?: number, LineNumber?: number, BillingAggregationStrategy?: { Name?: string } }, Warehouse?: { Name?: string }, Project?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_tasks/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
